import { useState } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { sweetAl } from "../../../../core/helpers/message-helper";
import useModal from "../../../../core/hooks/use-modal";
import useUser from "../../../../core/hooks/use-user";
import {
    activarTipoParametro,
    inactivarTipoParametro,
} from "../../services/tipos-parametros-service";

import FormTiposParametros from "../components/form-tipos-parametros";

const TiposParametros = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalTipoParametro = useModal({
        title: "Crear Tipo de Parametro",
        data: { tipoParametro: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSaved = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("crearTiposParametros")) {
        tableButtons.push({
            titleAttr: "Agregar Tipo de Parametro",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalTipoParametro.open({
                    title: "Agregar Tipo de Parametro",
                    data: { tipoParametro: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("editarTiposParametros")) {
        tableButtons.push({
            titleAttr: "Editar Tipo de Parametro",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalTipoParametro.open({
                    title: "Editar Tipo de Parametro",
                    data: { tipoParametro: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("inactivarTiposParametros")) {
        tableButtons.push({
            titleAttr: "Inactivar Tipo de Parametro",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar este Tipo de Parametro?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha inactivado el Tipo de Parametro"
                        );
                        break;
                    case "eliminar": {
                        const resp = await inactivarTipoParametro(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el Tipo de Parametro"
                            );
                        }

                        sweetAl.success(
                            "El Tipo de Parametro fue inactivado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("activarTiposParametros")) {
        tableButtons.push({
            titleAttr: "Activar Tipo de Parametro",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar este Tipo de Parametro?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha activado el Tipo de Parametro"
                        );
                        break;
                    case "activar": {
                        const resp = await activarTipoParametro(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el Tipo de Parametro"
                            );
                        }

                        sweetAl.success(
                            "El Tipo de Parametro fue activado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "tipo-parametros",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaTiposParametros",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/tiposParametros`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error listanto los tipos parametros"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "descripcion" },
            { data: "codigo" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [4],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Tipos De Parametros
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaTiposParametros"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Codigo</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            {
                <FormTiposParametros
                    modalState={modalTipoParametro}
                    onSaved={onSaved}
                />
            }
        </ContentWrapper>
    );
};

export default TiposParametros;
